"use strict";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


var siHome = document.querySelector(".home");
if (siHome) {

  ///////// le graphique
  const bars = document.querySelectorAll(".chart__bar");
  const maxValue = 3000;
  const maxHeight = 260;

  gsap.fromTo(
  bars,
  { height: 0 },
  {
      height: (i, el) => {
      const value = el.dataset.value;
      return (value / maxValue) * maxHeight;
      },
      duration: 0.9,
      ease: "power3.out",
      stagger: 0.2,
      scrollTrigger: {
      trigger: ".chart",
      start: "top 70%",
      toggleActions: "play none none none"
      }
  }
  );


  /////////// le count up
  document.querySelectorAll('.data__chiffre').forEach(el => {
    const endValuecu   = parseInt(el.dataset.target, 10);
    const isInfinitecu = el.dataset.infinite === "true";
  
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom", // quand le haut de la div touche le bas de l’écran
      onEnter: () => {
        gsap.fromTo(el,
          { innerText: 0 },
          {
            innerText: endValuecu,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 },
            onComplete() {
              if (isInfinitecu) el.innerHTML = '<i class="fa-solid fa-infinity"></i>';
            }
          }
        );
      },
      once: true // ne le fait qu’une fois
    });
  });

  ////////// DATA BOX FADE IN (STAGGER) //////////

  gsap.from(".data__box", {
    opacity: 0,
    duration: 2,
    ease: "power2.out",
    stagger: 0.25, // une après l’autre
    scrollTrigger: {
      trigger: ".data",
      start: "top 80%",
      once: true
    }
  });


  /////////// le carousel
  const wrapper = document.querySelector('.slider__wrapper');
  const groups = document.querySelectorAll('.slider__group');
  const prevBtn = document.querySelector('.slider__nav--prev');
  const nextBtn = document.querySelector('.slider__nav--next');

  let currentIndex = 0;

  function updateSlider() {
    wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  prevBtn.addEventListener('click', () => {
    currentIndex = currentIndex === 0 ? groups.length - 1 : currentIndex - 1;
    updateSlider();
  });

  nextBtn.addEventListener('click', () => {
    currentIndex = currentIndex === groups.length - 1 ? 0 : currentIndex + 1;
    updateSlider();
  });

  //////////le scroll smooth
  ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 1.2,
    smoothTouch: 0.1,
    effects: true
  });


  //scroll reaval //////////////////////////////////:
  // depuis la gauche
  gsap.utils.toArray(".scrollLeft").forEach(el => {
    gsap.from(el, {
      x: -80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  // depuis la droite
  gsap.utils.toArray(".scrollRight").forEach(el => {
    gsap.from(el, {
      x: 80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  // depuis le bas
  gsap.utils.toArray(".scrollBottom").forEach(el => {
    gsap.from(el, {
      y: 80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  ///// le zoom par défaut
  ////////// SCROLL ZOOM – GÉNÉRIQUE //////////

  gsap.utils.toArray(".scrollZoom").forEach(el => {

    if (el.closest(".people") || el.closest(".articles")) return;

    gsap.from(el, {
      scale: 0.9,
      opacity: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });

  });


  ///// le zoom pour people
  gsap.from(".people .scrollZoom", {
    scale: 0.9,
    opacity: 0,
    duration: 2,
    ease: "power3.out",
    stagger: 0.25,
    scrollTrigger: {
      trigger: ".people",
      start: "top 85%",
      once: true
    }
  });

  
  ///// le zoom pour articles
  gsap.from(".articles .scrollZoom", {
    scale: 0.9,
    opacity: 0,
    duration: 2,
    ease: "power3.out",
    stagger: 0.2,
    scrollTrigger: {
      trigger: ".articles",
      start: "top 85%",
      once: true
    }
  });




  ////////// le 2 part only right scrolls
  // const sections = gsap.utils.toArray(".vertical-section");

  // sections.forEach((section) => {
  //   const large = section.querySelector(".large-child");
    
  //   gsap.to(large, {
  //     y: () => -(large.scrollHeight - section.offsetHeight + 50), // décalage maximum
  //     ease: "none",
  //     scrollTrigger: {
  //       trigger: section,
  //       pin: section.querySelector(".difference__left"),
  //       start: "top top",
  //       // end: () => "+=" + (large.scrollHeight - section.offsetHeight),
  //       end: () => "+=1000",
  //       scrub: 0.5,
  //       invalidateOnRefresh: true,
  //       // markers: true
  //     }
  //   });
  // });

  ScrollTrigger.matchMedia({

    // Desktop only
    "(min-width: 1000px)": function () {

      const sections = gsap.utils.toArray(".vertical-section");

      sections.forEach((section) => {
        const large = section.querySelector(".large-child");

        gsap.to(large, {
          y: () => -(large.scrollHeight - section.offsetHeight + 50),
          ease: "none",
          scrollTrigger: {
            trigger: section,
            pin: section.querySelector(".difference__left"),
            start: "top top",
            end: "+=1000",
            scrub: 0.5,
            invalidateOnRefresh: true
            // markers: true
          }
        });
      });

    }

  });



  /////// accordeon
  const faqItems = document.querySelectorAll(".accordion__item");

  faqItems.forEach(item => {
    const btnAccord = item.querySelector(".accordion__question");

    btnAccord.addEventListener("click", () => {
      // close other items
      faqItems.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
          i.querySelector(".icon").textContent = "+";
        }
      });

      // toggle current item
      item.classList.toggle("active");

      const icon = item.querySelector(".icon");
      icon.textContent = item.classList.contains("active") ? "–" : "+";
    });
  });

  ///////////ANCHOR SCROLL FIX
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener("click", e => {
      const targetID = link.getAttribute("href");
  
      if (targetID === "#") return;
  
      const target = document.querySelector(targetID);
      if (!target) return;
  
      e.preventDefault();
  
      const smoother = ScrollSmoother.get();
      smoother.scrollTo(target, true, "top top");
    });
  });

}


var siSol = document.querySelector(".page-solutions");
if (siSol) {

  //////////le scroll smooth
  ScrollSmoother.create({
    wrapper: "#smooth-wrapper-sol",
    content: "#smooth-content-sol",
    smooth: 1.2,
    smoothTouch: 0.1,
    effects: true
  });

  //scroll reaval //////////////////////////////////:
  // depuis la gauche
  gsap.utils.toArray(".scrollLeft").forEach(el => {
    gsap.from(el, {
      x: -80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  // depuis la droite
  gsap.utils.toArray(".scrollRight").forEach(el => {
    gsap.from(el, {
      x: 80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  // depuis le bas
  gsap.utils.toArray(".scrollBottom").forEach(el => {
    gsap.from(el, {
      y: 80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  ///// le zoom par défaut
  ////////// SCROLL ZOOM – GÉNÉRIQUE //////////

  gsap.utils.toArray(".scrollZoom").forEach(el => {

    gsap.from(el, {
      scale: 0.9,
      opacity: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });

  });
}

var siArticle = document.querySelector(".page-article");
if (siArticle) {
  
  //scroll reaval //////////////////////////////////:
  // depuis la gauche
  gsap.utils.toArray(".scrollLeft").forEach(el => {
    gsap.from(el, {
      x: -80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  // depuis le bas
  gsap.utils.toArray(".scrollBottom").forEach(el => {
    gsap.from(el, {
      y: 80,
      opacity: 0,
      duration: 2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });
  });

  ///// le zoom par défaut
  ////////// SCROLL ZOOM – GÉNÉRIQUE //////////

  gsap.utils.toArray(".scrollZoom").forEach(el => {

    gsap.from(el, {
      scale: 0.9,
      opacity: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true
      }
    });

  });
}



const ContactPage = document.querySelector(".body__contact");

if (ContactPage) {

  const form = document.getElementById('contact-form');
  const objetSelect = document.getElementById('objet');
  const objetAutre = document.getElementById('objet-autre');

  objetSelect.addEventListener('change', () => {
  if (objetSelect.value === 'autre') {
      objetAutre.classList.remove('contact__input--hidden');
      objetAutre.required = true;
  } else {
      objetAutre.classList.add('contact__input--hidden');
      objetAutre.required = false;
      objetAutre.value = '';
  }
  });

  form.addEventListener('submit', (e) => {
  e.preventDefault(); // Empêche l'envoi tant que tout n'est pas validé
  let errors = [];

  // Vérifie prénom
  const prenom = form.querySelector('[name="prenom"]');
  if (!prenom.value.trim()) errors.push('Prénom');

  // Vérifie nom
  const nom = form.querySelector('[name="nom"]');
  if (!nom.value.trim()) errors.push('Nom');

  // Vérifie email
  const email = form.querySelector('[name="email"]');
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.value.trim()) {
      errors.push('Email');
  } else if (!emailPattern.test(email.value)) {
      errors.push('Email (format invalide)');
  }

  // Vérifie objet
  if (!objetSelect.value) errors.push('Objet');

  // Vérifie objet-autre si visible
  if (!objetAutre.classList.contains('contact__input--hidden') && !objetAutre.value.trim()) {
      errors.push('Objet (champ autre)');
  }

  // Vérifie message
  const message = form.querySelector('[name="message"]');
  if (!message.value.trim()) errors.push('Message');

  if (errors.length > 0) {
      alert('Veuillez remplir correctement les champs suivants :\n- ' + errors.join('\n- '));
      return false;
  }

  // Si tout est ok, envoie le formulaire
  form.submit();
  });


}